import './App.css';
import  Unity, { UnityContext } from "react-unity-webgl";
import {ErgoDappConnector} from "ergo-dapp-connector";


  const  unityContext = new UnityContext({
    loaderUrl: "build/public.loader.js",
    dataUrl: "build/public.data",
    frameworkUrl: "build/public.framework.js",
    codeUrl: "build/public.wasm",
  });

  // function handleClickSpawnEnemies() {
  //   sendMessage("MenuManager", "ConnectWallet", 100);
  // }

function App() {
  return (
    <div className="App">
      <h1>Welcome to Spooky Hunt</h1>
      <div className="button">
        <ErgoDappConnector  color="orange"/>
      </div>

      <Unity
     
      style={{
        width: '80%',

        justifySelf: 'center',
        alignSelf: 'center',
      }}

      unityContext={unityContext}
      />


    </div>
    
  );
}

export default App;
